import { InvoiceApi } from '@/api';
import { apiConfiguration } from '@/api/config';

export const invoiceApi = new InvoiceApi(apiConfiguration);

export const getInvoicesFn = async () => {
    return invoiceApi.invoiceControllerGetInvoices();
};

export const getPaymentIntentForInvoice = async (id: string) => {
    return invoiceApi.invoiceControllerGetPaymentIntentForInvoice(id);
};

export const getPaymentIntentForEstimate = async (id: string) => {
    return invoiceApi.invoiceControllerClientSecretForEstimateNew(id);
};
